<template>
  <!-- Sign In area -->
  <div class="sign-in">
    <v-container v-if="this.cart.length > 0">
      <v-layout row>
        <v-flex xs12 sm12>
          <v-card>
            <v-card-text>
              <v-container >
                <h1>Kirjaudu Sisään</h1>
                <form @submit.prevent="signInCheckout">
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="email"
                        name="Sähköposti"
                        placeholder="Sähköposti"
                        type="email"
                        required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="password"
                        name="Salasana"
                        placeholder="Salasana"
                        type="password"
                        required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-btn block class="main_color" dark type="submit">Lähetä</v-btn>
                    </v-flex>
                  </v-layout>
                  <!-- Hesabın yok mu? <router-link to="/create-account">Hesap Oluştur</router-link> -->
                  <p style="color:red">{{feedback}}</p>
                </form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="this.cart.length <= 0">
      <v-layout row>
        <v-flex xs12 sm12>
          <v-card>
            <v-card-text>
              <v-container>
                <h1>Kirjaudu Sisään</h1>
                <form @submit.prevent="signIn">
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="email"
                        name="Sähköposti"
                        placeholder="Sähköposti"
                        type="email"
                        required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="password"
                        name="Salasana"
                        placeholder="Salasana"
                        type="password"
                        required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-btn block class="main_color" dark type="submit">Lähetä</v-btn>
                    </v-flex>
                  </v-layout>
                  <!-- Hesabın yok mu ?<router-link to="/create-account">Hesap Oluştur</router-link> -->
                  <p style="color:red">{{feedback}}</p>
                </form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
     
<script>
  import firebase from "firebase";   
  export default {
  data(){
    return{           
      email:null,
      password:null,               
      cart:this.$store.getters.cart,    
      userLoggedin:null,
      feedback:null,            
    }
  },
  methods:{
    signInCheckout(){
      firebase.auth().signInWithEmailAndPassword(this.email,this.password)
        .then((user)=>{
            this.$router.replace('/')
            location.reload();                                    
        })
        .catch((e)=>{
            this.feedback = "Wrong mail or password"                    
        })
    },
    signIn(){
      firebase.auth().signInWithEmailAndPassword(this.email,this.password)
      .then((user)=>{
          this.$router.replace('/')                                              
      })
      .catch((e)=>{
          this.feedback = "Wrong mail or password"                    
      })
    }
  },   
  }
</script>
  
<style scoped>
  .sign-in{
    margin-top:0!important;
    height:70.2vh;
  }
  a{
    text-decoration: underline;
    color:#345B2C!important;   
  }
  .primary--text {
  color: #345B2C !important;
  caret-color: #345B2C !important;
}

</style>



// WEBPACK FOOTER //
// src/components/shop/checkout/SignIn.vue